
<div class="w-full hidden lg:flex flex-row justify-center fourth-row-container">
  <div class="w-full max-w-1440 flex lg:flex-row flex-col justify-between lg:items-center">
    <!-- Left side nav links -->
    <div class="hidden lg:flex items-center space-x-6 h-full font-rubik">
      <!-- Static link for 'About' -->
      <div
        :class="['nav-link', isActive(aboutSlug) ? 'active' : '', 'flex items-center px-3 h-full']"
        :style="isActive(aboutSlug) ? { '--active-color': brandColor } : {}"
      >
        <a
          :href="aboutSlug"
          class="subheader-nav-links mt-1"
          :style="isActive(aboutSlug) ? { color: brandColor } : { color: '#0c0e20' }"
        >
          About
        </a>
      </div>
      <!-- Dynamic links from solutionsArr -->
      <div
        v-for="solution in solutionsArr"
        :key="`nav-row-solution-${solution.title}`"
        :class="['nav-link', isActive(solution.slug) ? 'active' : '', 'flex items-center px-1 h-full']"
        :style="isActive(solution.slug) ? { '--active-color': brandColor } : {}"
      >
        <a
          :href="solution.slug"
          class="subheader-nav-links"
          :style="isActive(solution.slug) ? { color: brandColor } : { color: '#0c0e20' }"
        >
          {{ solution.title }}
        </a>
      </div>
    </div>
    
    <!-- Right side Partner and City -->
    <div class="flex items-center justify-between flex-row-reverse lg:flex-row lg:space-x-4 lg:mb-1">
      <div class="flex flex-row items-center gap-3">
        <p class="bottom-section-partner-name">Partner <span>{{ organization.name }}</span></p>
        <p v-if="city && state" class="bottom-section-location flex items-center"> 
          <img class="h-4" src="@/images/header/location_on_II.svg" alt="Service area location">
          {{ `${city}, ${state}` }}
        </p>
        <p v-else-if="organization.data['service_area']" class="bottom-section-location flex items-center"> 
          <img class="h-4" src="@/images/header/location_on_II.svg" alt="Service area location">
          {{ organization.data['service_area'] }}
        </p>
      </div>      
    </div>
  </div>
</div>
